export function media(image, size = "large") {
    if (!image) {
        return null;
    }

    if (typeof image === "string") {
        return image;
    }

    if (!(size in image)) {
        return null;
    }

    return image[size];
}
